import { render, staticRenderFns } from "./OfferRejected.vue?vue&type=template&id=36d6c80c&scoped=true&"
import script from "./OfferRejected.vue?vue&type=script&lang=js&"
export * from "./OfferRejected.vue?vue&type=script&lang=js&"
import style0 from "./OfferRejected.vue?vue&type=style&index=0&id=36d6c80c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d6c80c",
  null
  
)

export default component.exports